/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   ShortTermHomepageDesktop
 */

/** @jsx jsx */
import { jsx } from '@emotion/react'
import * as styles from '../style'

import { HeaderText } from './HeaderText/HeaderText'
import { SearchFormContainer } from './SearchForm/SearchFormContainer'

export interface Props {
  isZumperRentals: boolean
}

export const HomepageHeaderDesktop = ({ isZumperRentals }: Props) => (
  <div css={styles.contentContainer}>
    <HeaderText isZumperRentals={isZumperRentals} />
    <div css={styles.content}>
      <SearchFormContainer />
    </div>
  </div>
)
